import { FC } from 'react';
import * as React from 'react';

import { FormRenderProps } from 'react-final-form';
import { ModalComponentProps } from '../modal/ModalManager';
import { Dialog } from '../dialog/Dialog';
import { DialogBody } from '../dialog/DialogBody';
import { Card } from '../card/Card';
import { Block } from '../block/Block';
import {
  Button,
  CloseButton,
  DialogFooter,
  modalFormDialog,
  VF,
} from '../index';

type HtmlDialogFormData = {
  html?: string;
};

type HtmlDialogProps = {
  formRenderProps: FormRenderProps<HtmlDialogFormData>;
} & ModalComponentProps;

const HtmlDialog: FC<HtmlDialogProps> = ({
  onClose,
  formRenderProps: { handleSubmit, submitting },
}) => {
  return (
    <Dialog
      style={{ height: '90vh' }}
      size={'xxl'}
      onClose={onClose}
      title={'Zdrojový kód'}
    >
      <DialogBody>
        <Card
          mode={'edit'}
          className={'h-100'}
          noScroll
          bodyClassName={'h-100'}
        >
          <Block className={'h-100'} noScroll bodyClassName={'h-100'}>
            <VF.TextArea
              contentClassName={'h-100'}
              inputClassName={'h-100'}
              className={'h-100'}
              name={'html'}
              label={false}
            />
          </Block>
        </Card>
      </DialogBody>
      <DialogFooter>
        <CloseButton mode={'edit'} disabled={submitting} onClick={onClose} />
        <Button disabled={submitting} style={'primary'} onClick={handleSubmit}>
          Ok
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export const HtmlModalForm = modalFormDialog<
  HtmlDialogFormData,
  HtmlDialogProps
>(HtmlDialog, {
  // validate: validation,
});
